import { Flex } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import SelectableButton from "components/Button/SelectableButton";
import InputSearch from "components/Input/InputSearch";
import ExportMenu from "components/ExportMenu";
import { OperacaoEnum } from "core/resources/enums/conta";
import useDownloadRenderedPdf from "infra/helpers/useDownloadRenderedPdf";
import moment from "moment";
import PDFRelatorioBalancoFinanceiro from "../../PDFRelatorio";
import useRelatorioBalancoFinanceiroPdf from "core/features/relatorios/hooks/useRelatorioBalancoFinanceiroPdf";
import {
  FiltroRelatorioBalancoFinanceiro,
  BalancoFinanceiroResponse,
} from "core/features/relatorios/typings";
import { useState } from "react";
import ModalAssinaturasRelatorio from "components/Relatorio/ModalAssinaturas";
import { AssinaturasItem } from "components/Relatorio/FormAssinaturas";

export interface HeaderTableProps {
  onSearch: (q?: string) => void;
  value: string;
  operacao?: OperacaoEnum;
  onSelectOperacao?: (operacao: OperacaoEnum | undefined) => any;
  filtro?: FiltroRelatorioBalancoFinanceiro;
  data?: BalancoFinanceiroResponse;
}

function HeaderTable({
  onSearch,
  value,
  operacao,
  onSelectOperacao,
  filtro,
  data,
}: HeaderTableProps) {
  const [modalAssinaturasOpen, setModalAssinaturasOpen] = useState(false);
  const onUnselect = () => onSelectOperacao?.(undefined);

  const {
    refetch,
    isLoading: isLoadingPdf,
    isFetching: isFetchingPdf,
  } = useRelatorioBalancoFinanceiroPdf(filtro);

  const { onDownload: onExportPdf } = useDownloadRenderedPdf({
    fileName: `Relatório de Balanço Financeiro - ${moment().format(
      "DD_MM_YYYY"
    )}`,
    Component: PDFRelatorioBalancoFinanceiro,
    loading: isLoadingPdf || isFetchingPdf,
  });

  const _onExportPdf = () => setModalAssinaturasOpen(true);

  const onSubmitAssinaturas = (assinaturas: AssinaturasItem[]) => {
    if (!isLoadingPdf) {
      refetch().then(({ data }) => {
        if (data) {
          onExportPdf({ data: { ...data, assinaturas } });
          setModalAssinaturasOpen(false);
        }
      });
    }
  };

  return (
    <Flex flexDir="column">
      <Flex gridGap="16px" flexWrap="wrap">
        <Flex w="100%" maxW="350px">
          <InputSearch defaultValue={value} onSearch={(v) => onSearch(v)} />
        </Flex>

        <Flex flex={1} gridGap={4} flexWrap="wrap">
          <Flex flex={1} pt="4px">
            <Flex gridGap="16px">
              <SelectableButton
                selected={operacao === OperacaoEnum.Receita}
                onClick={() => onSelectOperacao?.(OperacaoEnum.Receita)}
                onUnselect={onUnselect}
                rounded="full"
                selectedColor={colors.green500}
                fontSize="14px"
              >
                Receitas
              </SelectableButton>
              <SelectableButton
                selected={operacao === OperacaoEnum.Despesa}
                onClick={() => onSelectOperacao?.(OperacaoEnum.Despesa)}
                onUnselect={onUnselect}
                rounded="full"
                selectedColor={colors.red500}
                fontSize="14px"
              >
                Despesas
              </SelectableButton>
            </Flex>
          </Flex>
          <Flex>
            <ExportMenu
              onExportPdf={_onExportPdf}
              // onExportarXlsx={() =>
              //   exportExcelRelatorioDemonstrativoReceitaDespesa({
              //     receitas,
              //     despesas,
              //     filtro: filtro!,
              //     totais,
              //     transferencias,
              //   })
              // }
            />
          </Flex>
        </Flex>
      </Flex>
      <ModalAssinaturasRelatorio
        isOpenModal={modalAssinaturasOpen}
        onClose={() => setModalAssinaturasOpen(false)}
        onSubmit={onSubmitAssinaturas}
      />
    </Flex>
  );
}

export default HeaderTable;
